import { GET_PREISMODELLE_BY_STANDORT_ID } from '@/domain/navigation/features/navigation/hooks/useVertraege/graphql/queries';
import { CURRENT_PREISMODELL } from '@/domain/navigation/features/navigation/hooks/useVertraege/preismodelle';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import {
  GetPreismodelleByStandortIdQuery,
  GetPreismodelleByStandortIdQueryVariables,
} from '@/gql/graphql';
import { useSuspenseQuery } from '@apollo/client';
import * as Sentry from '@sentry/react';

export function useHasUpgradableVertrag(): {
  hasUpgradableVertrag: boolean;
  error?: string;
} {
  const { standorte } = useStandortContext();
  const standortIds = standorte.map((standort) => standort.id);

  const { data, error } = useSuspenseQuery<
    GetPreismodelleByStandortIdQuery,
    GetPreismodelleByStandortIdQueryVariables
  >(GET_PREISMODELLE_BY_STANDORT_ID, {
    variables: {
      standortIds,
    },
  });

  if (error) {
    Sentry.captureException(error);
    return { hasUpgradableVertrag: false };
  }

  const hasUpgradableVertrag = data.vertraegeByIdStandort.some(
    (vertrag) => vertrag.preisModell !== CURRENT_PREISMODELL,
  );

  return { hasUpgradableVertrag };
}
